export const reportTableConfig = {
  live_job_pipeline_table: {
    title: 'Current job pipeline',
    metricDefinition: 'Current snapshot of candidates across jobs',
    id: 'live_job_pipeline_table',
    basedOn: 'Current pipeline snapshot',
    category: 'Current job pipeline',
  },
  pipeline_table: {
    title: 'Pipeline history',
    metricDefinition: 'Comprehensive breakdown of the pipeline data',
    id: 'pipeline_table',
    basedOn: 'Application creation date',
    category: 'Pipelines',
  },
  interviews_table: {
    title: 'Interview breakdown',
    metricDefinition: 'Comprehensive breakdown of the interviews data',
    id: 'interviews_table',
    basedOn: 'Interview date',
    category: 'Interviews',
  },
  offers_table: {
    title: 'Offer breakdown',
    metricDefinition: 'Comprehensive breakdown of the offers data',
    id: 'offers_table',
    basedOn: 'Offer creation date',
    category: 'Offers',
  },
  hires_table: {
    title: 'Hire breakdown',
    metricDefinition: 'Comprehensive breakdown of the hires data',
    id: 'hires_table',
    basedOn: 'Hire date',
    category: 'Hires',
  },
  rejections_table: {
    title: 'Rejection breakdown',
    metricDefinition: 'Comprehensive breakdown of the rejections data',
    id: 'rejections_table',
    basedOn: 'Rejection date',
    category: 'Rejections',
  },
  contacts_table: {
    title: 'Contact breakdown',
    metricDefinition: 'Comprehensive breakdown of the contacts data',
    id: 'contacts_table',
    basedOn: 'Contact creation date',
    category: 'Contacts',
  },
  jobs_table: {
    title: 'Job breakdown',
    metricDefinition: 'Comprehensive breakdown of the jobs data',
    id: 'jobs_table',
    basedOn: 'Job creation date',
    category: 'Jobs',
  },
  eeoc_race_table: {
    title: 'Race',
    metricDefinition: 'Breakdown of the races',
    id: 'eeoc_race_table',
    basedOn: 'Application creation date',
    category: 'EEOC',
  },
  eeoc_veteran_table: {
    title: 'Veteran status',
    metricDefinition: 'Breakdown of the veteran status',
    id: 'eeoc_veteran_table',
    basedOn: 'Application creation date',
    category: 'EEOC',
  },
  eeoc_disability_table: {
    title: 'Disability status',
    metricDefinition: 'Breakdown of the disability status',
    id: 'eeoc_disability_table',
    basedOn: 'Application creation date',
    category: 'EEOC',
  },
  flow_health: {
    title: 'Candidate touchpoint',
    metricDefinition:
      'Comprehensive breakdown of the candidate touchpoints data',
    id: 'flow_health',
    basedOn: 'Flow creation date',
    category: 'Flows',
  },
  flow_user_activity: {
    title: 'User activity',
    metricDefinition: 'Comprehensive breakdown of the user activity data',
    id: 'flow_user_activity',
    basedOn: 'Flow creation date',
    category: 'Flows',
  },
  recruiter_performance_table: {
    title: 'Recruiter performance',
    metricDefinition: 'Comprehensive breakdown of the recruiter performance',
    id: 'recruiter_performance_table',
    category: 'Recruiter performance',
  },
  requisitions_table: {
    title: 'Requisition breakdown',
    metricDefinition: 'Comprehensive breakdown of requisitions data',
    id: 'requisitions_table',
    basedOn: 'Requisition open date',
    category: 'Requisitions',
  },
  survey_table: {
    title: 'NPS breakdown',
    metricDefinition: 'Comprehensive breakdown of the aggregate NPS data',
    id: 'survey_table',
    basedOn: 'Submission date',
    category: 'Survey',
  },
};
